import { render } from "./basic-date-table.vue?vue&type=template&id=c8bab4f2&ts=true"
import script from "./basic-date-table.vue?vue&type=script&lang=ts"
export * from "./basic-date-table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__